import React, {ReactNode} from 'react';
import styles from './style.module.scss';

interface IProps {
    content: ReactNode[]
    className?: string
    gridTemplateColumns?: string
}

const Columns: React.FC<IProps> = ({content, className, gridTemplateColumns}) => {
    return <div
        className={[styles.columns, className].join(" ")}
        style={{gridTemplateColumns: gridTemplateColumns ?? `repeat(${content.length}, 1fr)`}}
    >
        {content.map((item, i) => <div className={styles.column} key={i}>
            {item}
        </div>)}
    </div>;
};

export default Columns;
